import { memo } from 'react';
import type { CSSProperties, ReactElement } from 'react';
import { clsx } from 'clsx';
import type { BaseClickEvent } from '../buttons';
import { getClickableAriaOptions } from '../buttons';
import type { TableDataProps } from './TableCell';
import styles from './Table.module.scss';

export type RowAlign = 'baseline' | 'middle' | 'top' | 'bottom';
export interface TableRowProps {
    /**
     * Apply one of the pre-defined hover effects to table row.
     * Undefined implies that no hover effect should be applied.
     */
    hoverEffect?: boolean;
    children:
        | ReactElement<TableDataProps>
        | (ReactElement<TableDataProps> | boolean)[];
    /**
     * The onPress callback for row
     */
    onPress?: (e?: BaseClickEvent) => void;
    /**
     * The html role of element
     */
    role?: string;
    /**
     * The vertical align of cell
     */
    verticalAlign?: RowAlign;
    /**
     * The height of row
     */
    height?: CSSProperties['height'];
}

const TableRow = ({
    hoverEffect,
    children,
    onPress,
    role,
    verticalAlign,
    height,
}: TableRowProps) => {
    const baseProps = onPress ? getClickableAriaOptions({ onPress, role }) : {};
    return (
        <tr
            className={clsx(styles.tableRow, {
                [styles.hoverEffect]: hoverEffect,
            })}
            style={{
                verticalAlign,
                height,
            }}
            {...baseProps}
        >
            {children}
        </tr>
    );
};

export default memo(TableRow);
